const MESSAGE_CLOSE_CLASS = 'message_link_close'

const MESSAGE_TYPE = {
    COMMON: 'common',
    WAITING: 'waiting',
    SUCCESS: 'success',
    ERROR: 'error'
}

const MESSAGE_BACKEND_TAGS = {
    link_tos_start: '<a target="_blank" rel="noopener" href="{terms_url}">',
    link_tos_end: '</a>',
    link_close_start: `<a class="${MESSAGE_CLOSE_CLASS}" href="#">`,
    link_close_end: '</a>'
}

export { MESSAGE_TYPE, MESSAGE_BACKEND_TAGS, MESSAGE_CLOSE_CLASS }
